<template>
  <div class="jumplink">
    <dotcom-icon
      name="arrow-right-long"
      art="regular"
      class="jumplink-icon"
      color="--c-primary-color-3"
      hover-color="--c-tint-color-1"
    />
    <a :href="href" :target="target" class="jumplink__link">
      <slot name="default" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'Jumplink',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    href: {
      type: String,
      default: 'https://www.sanitas.com/',
    },
    target: {
      type: String,
      default: '_self',
    },
  },
}
</script>

<style scoped>
.jumplink {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: normal;

  .jumplink-icon {
    position: absolute;
  }

  &:hover {
    cursor: pointer;
  }
}

.jumplink__link {
  font-weight: 700;
  font-style: normal;
  font-size: 15px;
  line-height: normal;
  letter-spacing: 0.25px;
  color: var(--c-primary-color-3);
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease-in-out 0s;
  display: inline-block;
  padding-left: 23px;

  border-bottom: none; /* overwriting global leaking styles */

  &:hover {
    color: var(--c-tint-color-1);
    text-decoration: underline;
  }
}
</style>
